<template>
    <div v-wechat-title="title" class="padding10">
        <!-- <el-row type="flex" align="right">
            <el-col :md="24" :xl="24" class="align-right">
                <el-button type="primary" size="mini" @click="saveDrug">保存</el-button>
            </el-col>
        </el-row> -->
        <div class="fg-danger align-left" style="padding: 10px 0 5px 20px">提示:仅对当前手术生效</div>
        <cus-form ref="form-saveas" :data="timeRulerSettingdata" width="95%" :columns="columnList" @extrabutton-click="ExtraButtonClick" @confirm="SaveAs"></cus-form>
        <CloseButton ref="close-btn" type="confirm" @confirm="confirm" :msg="msg"> </CloseButton>
        <!-- <cus-dialog class="table-h360" title="时间轴设置" :close-on-click-modal="false" width="60%" @confirm="savecompoundDrug">
            <ListView :columns="listcolumnList" :rowNoStyle="true" :datalist="data"></ListView>
        </cus-dialog> -->
    </div>
</template>
<script>
export default {
    name: `TimeRulerSettings`,
    props: {

    },
    data() {
        return {
            title: `时间轴设置`,
            token: this.$route.query.token,
            surgery_id: this.$route.query.surgery_id,
            recordType: this.$route.query.recordType,
            timeRulerSettingdata: {
                templates: [
                    {
                        id: 1,
                        begin_time: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        end_time: this.$moment().add(5, `minutes`).format(`YYYY/MM/DD HH:mm`),
                        interval: 1,
                        biz_surgery_info_id: 1,
                        remark: `第一次抢救`
                    }, {
                        id: 2,
                        begin_time: this.$moment().add(20, `minutes`).format(`YYYY/MM/DD HH:mm`),
                        end_time: this.$moment().add(30, `minutes`).format(`YYYY/MM/DD HH:mm`),
                        interval: 1,
                        biz_surgery_info_id: 1,
                        remark: `第二次抢救`
                    }, { is_empty: true, interval: 1 }

                ]
            },
            msg: `closeWindow`,
            textarea: ``
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
        this.initdata()
    },
    computed: {
        columnList() {
            return [
                {
                    type: `table2`,
                    prop: `templates`,
                    label: { position: `top`, content: ` ` },
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `排序`,
                            isKey: true
                        },
                        {
                            type: `datetime`,
                            prop: `begin_time`,
                            label: `开始时间`,
                            width: `180`,
                            isListable: true,
                            readonly: false,
                            config: {
                                datetimeFormate: `yyyy/MM/dd HH:mm`,
                                noPadding: true,
                                editable: true
                            },
                            change: (that, { changetext, changeid, index, row, prop, column }) => {
                                if (row.is_empty) {
                                    this.$set(row, `is_empty`, false)
                                    this.$set(row, `end_time`, this.$moment(row.begin_time).add(30, `minutes`).format(`YYYY/MM/DD HH:mm`))
                                    this.timeRulerSettingdata.templates.push({ is_empty: true, interval: 1 })
                                } else {
                                    this.$set(row, `end_time`, this.$moment(row.begin_time).add(30, `minutes`).format(`YYYY/MM/DD HH:mm`))
                                }
                            }
                        },
                        {
                            type: `datetime`,
                            prop: `end_time`,
                            label: `结束时间`,
                            width: `180`,
                            isListable: true,
                            readonly: false,
                            config: {
                                datetimeFormate: `yyyy/MM/dd HH:mm`,
                                noPadding: true,
                                editable: true
                            }
                        },
                        {
                            type: `select`,
                            prop: `interval`,
                            label: `间隔(分钟)`,
                            width: `100`,
                            isListable: true,
                            readonly: false,
                            options: [
                                { value: `1`, label: `1分钟` },
                                { value: `5`, label: `5分钟` },
                                { value: `10`, label: `10分钟` },
                                { value: `15`, label: `15分钟` },
                                { value: `30`, label: `30分钟` },
                                { value: `60`, label: `60分钟` }
                            ],
                            default: 1
                        },
                        {
                            type: `string`,
                            label: `备注`,
                            prop: `remark`,
                            isListable: true,
                            readonly: false,
                            config: {
                                'popper-append-to-body': true
                            }
                        },
                        {
                            type: `buttongroup`,
                            prop: `oper`,
                            label: `操作`,
                            width: `100`,
                            isListable: true,
                            fixed: `right`,
                            options: (that, { row }) => {
                                return row.is_empty || row.is_key_event
                                    ? []
                                    : [
                                        {
                                            class: `is-plain is-circle`,
                                            label: ``,
                                            icon: `el-icon-close`,
                                            type: `danger`,
                                            emit: `removeItem`,
                                            permission: `default`
                                        }
                                    ]
                            }
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        showSequence: false,
                        height: this.screenHeight2 - 108
                    }
                }
            ]
        }
    },
    methods: {
        ExtraButtonClick(target) {
            this[target.emit] && this[target.emit](target)
        },
        SaveAs(row) {
            let that = this
            let record = _.filter(row.templates, d => !d.is_empty)
            let datas = _.map(record, d => {
                d.biz_surgery_info_id = that.surgery_id
                if (d.end_time.indexOf(`/Date`) > -1) {
                    d.end_time = this.$moment(d.end_time).format(`YYYY/MM/DD HH:mm`)
                }
                if (d.begin_time.indexOf(`/Date`) > -1) {
                    d.begin_time = this.$moment(d.begin_time).format(`YYYY/MM/DD HH:mm`)
                }
                return d
            })
            for (var i = 0; i < datas.length; i++) {
                if (datas[i].begin_time == undefined || datas[i].end_time == undefined || datas[i].begin_time == `` || datas[i].end_time == `` || datas[i].begin_time == null || datas[i].end_time == null) {
                    this.$message.error(`第${i + 1}行开始时间或者结束时间不能为空！`)
                    return
                }
                if (datas[i].begin_time >= datas[i].end_time) {
                    this.$message.error(`第${i + 1}行开始时间不允许大于等于结束时间！`)
                    return
                }
                if (i > 0) {
                    let upendtime = datas[i - 1].end_time
                    let thisbegintime = datas[i].begin_time
                    if (upendtime >= thisbegintime) {
                        this.$message.error(`第${i + 1}行开始时间不允许小于等于第${i}行结束时间！`)
                        return
                    }
                }
            }
            return new Promise((resolve) => {
                let req = that.myaxios.post(`/api/AcisSystem/TimeRulerSetting/PostMany`, datas)
                req.then(data => {
                    this.sendMessage()
                    this.$refs[`close-btn`].close()
                }).catch(e => { console.log(e) })
            })

            // this.saveOne().then(data => {
            //     this.$refs[`close-btn`].close()
            // })
        },
        confirm($that) {
            this.$refs[`form-saveas`].confirm()
        },
        removeItem({ index }) {
            let that = this
            let row = this.timeRulerSettingdata.templates[index]
            if (row.id) {
                this.$confirm(`是否确定删除?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`
                }).then(() => {
                    let req = this.myaxios.delete(`/api/AcisSystem/TimeRulerSetting/DeleteById?id=${row.id}`)
                    req.then(data => {
                        that.initdata()
                    }).catch(e => {
                        console.log(e)
                    })
                })
            } else {
                // eslint-disable-next-line no-unused-expressions
                that.timeRulerSettingdata.templates.splice(index, 1)[0]
            }
        },
        initdata() {
            let that = this
            return new Promise((resolve) => {
                let req = that.myaxios.get(`/api/AcisSystem/TimeRulerSetting/GetBySurgeryInfoId?surgeryinfoId=${this.$route.query.surgery_id}`)
                req.then(data => {
                    console.log(data)
                    that.timeRulerSettingdata.templates = data
                    that.timeRulerSettingdata.templates.push({ is_empty: true, interval: 1 })
                }).catch(e => { console.log(e) })
            })
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: {},
                    action: `ok`
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/TimeRulerSettings.vue